import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		userInfo: {},
		hasLogin: false,
		imageList:[],
		leftForm:{}
	},
	mutations: {
		login(state, provider) {
			state.hasLogin = true
			state.userInfo.member = provider.member;
			state.userInfo.token = provider.token;
			sessionStorage.setItem('userInfo',JSON.stringify(provider))
		},
		logout(state) {
			state.hasLogin = false
			state.userInfo = {}
			sessionStorage.removeItem('userInfo')
		},
		updateLogin(state,data) {
			state.userInfo.member = data;
			sessionStorage.setItem('userInfo',JSON.stringify(state.userInfo))
		},
		setImageList(state,data){
			state.imageList = data;
		},
		getLeftForm(state,data){
			state.leftForm = data
		},
	},
	actions:{
		userLogin(context,data){
			context.commit('login',data)
		},
		userLogout(context){
			context.commit('logout')
		},
		getBtnLeft(context,data){
			context.commit('getLeftForm',data)
		},
	}
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js